import {
	EngineCommunicationChannels,
	LoggerAction,
	StorageUploadFileChannel,
} from '@webitel/api-services/gen/models';
import { RingtoneType } from '@webitel/ui-sdk/enums';
import { NotificationType } from '../../../modules/settings/modules/notifications/enums/NotificationType';

export default {
	auth: {
		register: 'Înregistrare',
		login: 'Autentificare',
		registerReset: 'Resetează parola',
		detailsSubtitle: 'Introduceți detaliile de mai jos',
		resetPasswordLink: 'Ai uitat parola?',
		user: 'Nume utilizator',
		password: 'Parolă',
		confirmPassword: 'Repetați parola',
		key: 'Cheie de licență',
		registerSubmit: 'Înregistrare',
		resetSubmit: 'Resetează',
		loginSubmit: 'Autentificare',
		carousel: {
			title1: 'Cloud vs. On-Site',
			text1:
				'Politica de securitate nu permite stocarea datelor și utilizarea serviciilor cloud? Cu Webitel, poți construi un centru de contact pe site-ul tău!',

			title2: 'Multichannel VS Omni-Channel',
			text2:
				'Fii mereu și în orice loc cu clienții tăi! Meniul IVR de orice complexitate, campanii outbound, interacțiuni inbound sau mesaje pe rețelele sociale - acum este mai ușor decât niciodată!',

			title3: 'Infrastructură fault-tolerantă',
			text3:
				'Nu mai există întreruperi neplanificate. Scalarea rapidă și arhitectura fault-tolerantă vă permite să serviți mai mult de 1000 apeluri de clienți pe minut din diferite canale de comunicare.',

			title4: 'Design',
			text4:
				'Interfața nouă minimalistică cu cel mai ușor panel de administrare care vă permite să aveți acces rapid la toate funcțiile necesare. Mai puține clicuri - mai multe funcționalități.',

			title5: 'Modul nou de lucru cu grupul de agenți',
			text5:
				'Distribuția celor mai eficiente apeluri. Un agent poate avea mai multe competențe în același timp pentru a participa la campanii diferite. Clientul este servit doar de profesioniști.',

			title6: 'Setare permisiuni',
			text6:
				'Modul nou de gestionare a permisiunilor - noi oportunități pentru control. Utilizatorii pot face modificări doar la secțiuni, precum și la acțiuni.',
		},
	},

	header: {
		logout: 'Deconectare',
		docs: 'Documentație',
	},

	appNavigator: {
		title: 'Aplicații Webitel',
		admin: 'Admin',
		agent: 'Foaia de lucru a agentului',
		supervisor: 'Foaia de lucru a supraveghetorului',
		audit: 'Audit',
		history: 'Istoric apeluri',
		grafana: 'Grafana',
	},

	settings: {
		settings: 'Setare | Setări',
		changePassword: 'Schimbă parola',
		language: 'Limbă',
		fallbackLanguage: 'Limba implicită',
		webPhone: 'WebPhone',
		useWebPhone: 'Folosește WebPhone',
		useStun: 'Folosește STUN',
		notifications: {
			[NotificationType.NewMessageSound]: 'Sunet pentru mesaj nou',
			[NotificationType.NewChatSound]: 'Sunet pentru chat nou',
			[NotificationType.SelfAssignedCallSound]:
				'Sunet pentru apel auto-asignat',
			[NotificationType.ChatEndSound]: 'Sunet la sfârșitul chat-ului',
			[NotificationType.CallEndSound]: 'Sunet la sfârșitul apelului',
			[NotificationType.TaskEndSound]: 'Sunet la sfârșitul sarcinii',
			[NotificationType.ChatEndPush]: 'Notificare push la sfârșitul chat-ului',
			[NotificationType.CallEndPush]: 'Notificare push la sfârșitul apelului',
			[NotificationType.TaskEndPush]: 'Notificare push la sfârșitul sarcinii',
			[NotificationType.SocketCloseSound]: 'Sunet la pierderea conexiunii',
		},
		ringtones: {
			title: 'Schimbă tonul apelului',
			ringtone: 'Ton',
			customRingtone: 'Folosește tonul personalizat',
		},
		ringtoneVolume: {
			title: 'Setări volum',
			[RingtoneType.Call]: 'Apel',
			[RingtoneType.Chat]: 'Chat',
			[RingtoneType.Task]: 'Sarcină',
		},
		security: {
			security: 'Securitate',
			logoutTitle: 'Deconectați acest utilizator de pe alte dispozitive',
		},
	},

	validation: {
		email: 'Ar trebui să arate ca un email',
		required: 'Acest câmp este obligatoriu',
		sameAs: 'Parolă incorectă',
		gatewayHostValidator: 'Ar trebui să arate ca un IPv4 sau FQDN',
		ipValidator: 'Ar trebui să arate ca un IPv4',
		macValidator: 'Ar trebui să arate ca un MAC',
		numeric: 'Ar trebui să fie numeric',
		requiredArrayValue: 'Matricea nu ar trebui să fie goală',
		isPositiveValue: 'Valoarea ar trebui să fie un număr pozitiv',
		cron: 'Expresie cron invalidă',
		hourRange: 'Orele trebuie să fie între 00 și 23',
		timerangeStartLessThanEnd:
			'Ora "De la" nu poate fi mai târzie decât "Până la"',
		timerangeNotIntersect:
			'Intervalele de timp din aceeași zi nu se pot suprapune',
	},

	nav: {
		directory: {
			directory: 'Director',
		},
		routing: {
			routing: 'Rutare',
		},
		lookups: {
			lookups: 'Căutări',
		},
		ccenter: {
			ccenter: 'Centru de contact',
		},
		integrations: {
			integrations: 'Integrări',
		},
		permissions: {
			permissions: 'Permisiuni',
		},
		system: {
			system: 'Sistem',
		},
	},

	home: {
		dashboard: 'Panou de bord',
		welcomeText: '',
		news: 'Știriri',
	},

	objects: {
		all: 'Toate {entity}',
		administration: 'Administrare',
		general: 'General',
		new: 'Nou',
		add: 'Adaugă',
		create: 'Creează',
		read: 'Citeste',
		edit: 'Editează',
		delete: 'Șterge',
		save: 'Salvează',
		saved: 'Salvat',
		saveAs: 'Salvează ca',
		close: 'Închide',
		next: 'Următorul',
		back: 'Înapoi',
		change: 'Schimbă',
		name: 'Nume',
		title: 'Titlu',
		description: 'Descriere',
		user: 'Utilizator',
		action: 'Acțiune',
		allow: 'Permite',
		password: 'Parolă',
		history: 'Istoric',
		copy: 'Copiază',
		copied: 'Copiat în clipboard!',
		createdAt: 'Creat',
		createdBy: 'Creat de',
		online: 'Online',
		offline: 'Offline',
		on: 'Pe',
		off: 'Off',
		ok: 'Ok',
		enabled: 'Activat',
		status: 'Status',
		from: 'De la',
		to: 'La',
		importJSON: 'Import JSON',
		addNew: 'Adaugă nou',
		provider: 'Furnizor',
		default: 'Implicit',
		service: 'Serviciu',
		tts: 'Text-to-Speech',
		stt: 'Speech-to-Text',
		key: 'Cheie',
		ID: 'ID',
		email: ({ linked }) => linked('vocabulary.emails'),
		updatedAt: 'Modificat',
		emptyWorkspace: 'Nu există încă înregistrări',
		emptyResultSearch: 'Căutarea ta nu a dat rezultate',

		deleteConfirmation: {
			title: 'Confirmare ștergere',
			askingAlert:
				'Sigur vrei să ștergi {count} element? | Sigur vrei să ștergi {count} elemente?',
			undoneActionAlert: 'Această acțiune nu poate fi anulată.',
			deleteAll: 'TOATE',
		},
		generalInfo: 'Informații generale',
		objectHeader: {},
		directory: {
			directory: 'Director',
			passwordInfo:
				'Introduceți valoarea doar dacă doriți să o editați (sau să creați una nouă). Câmpul gol va lăsa valoarea neschimbată',
			users: {
				users: 'Utilizator | Utilizatori',
				allUsers: 'Toți utilizatorii',
				searchPlaceholder: 'Nume, login, extensii, status',
				login: 'Login',
				extensions: 'Extensii',
				state: 'Stare',
				DnD: 'DnD',
				status: 'Status',
				roles: 'Roluri',
				tokens: 'Tokenuri',
				usage: 'Utilizare',
				expiryDays: 'Zile de valabilitate',
				expiryDate: 'Data expirării',
				roleAdmin: 'Admin',
				license: 'Licență',
				devices: 'Dispozitive',
				defaultDevice:
					'Dispozitiv implicit (din lista de dispozitive selectate)',
				deviceNotFound: 'Nu ați găsit dispozitivul?',
				createNewDevice: 'Adaugă nou',
				variables: 'Variabile',
				varKey: 'Cheie',
				varVal: 'Valoare',
				token: 'Token | Tokenuri',
				tokenPopupHeader: 'Cheia tokenului a fost creată cu succes!',
				tokenPopupText:
					'Descărcați fișierul cheie acum sau copiați-l. Dacă nu descărcați fișierul cheie acum, nu veți putea să recuperați cheia tokenului din nou. Pentru a vă proteja securitatea, stocați cheia tokenului în siguranță și nu o împărtiți.',
				tokenPopupCopy: 'Copiază în clipboard',
				tokenPopupSave: 'Salvează ca TXT',
				userIp: 'IP utilizator',
				userId: 'ID utilizator',
				download: 'Descarcă',
				regenerate: 'Regenerează',
				askingAlert:
					'Sigur vrei să regenerezi codul? Utilizatorul nu va putea să se autentifice',
				chatName: 'Nume de afișare în chat',
				temporaryPassword: 'Parolă temporară',
				communications: 'Comunicații',
				generateDevice: 'Generează dispozitiv',
				deviceGenerationTitle: 'Generare dispozitiv',
				deviceGeneration:
					'Această acțiune va crea automat un nou dispozitiv pentru acest utilizator.',
				deviceWasGenerated: 'Dispozitivul a fost generat',
				deviceGenerationConfirmTitle: 'Confirmați generarea dispozitivului',
				generateDeviceConfirmation:
					'Dispozitivele curente vor fi înlocuite cu cel generat. Continuați?',
				authorizationSecurity: 'Autorizare și securitate',
				mustChangePassword:
					'Utilizatorul trebuie să schimbe parola la prima conectare.',
				extensionsHelperText: 'Numărul intern trebuie să conțină doar cifre',
				csvMappingFields: {
					login: ({ linked }) => linked('vocabulary.login'),
					name: 'Nume',
					extension: ({ linked }) =>
						linked('objects.directory.users.extensions'),
					email: ({ linked }) => linked('vocabulary.emails'),
				},
				logout: {
					endAllSessions: 'Încheie toate sesiunile',
					endAllMySessions: 'Încheie toate sesiunile mele',
					endSessionConfirmation: 'Confirmare încheiere sesiuni',
					endSessionConfirmationText:
						'Sunteți sigur că doriți să încheiați toate sesiunile?',
					endMultipleSessionsConfirmationText:
						'Sigur doriți să închideți toate sesiunile pentru {count} utilizatori?',
					tooltip: 'Utilizatorul va fi deconectat de pe toate dispozitivele',
				},
			},
			license: {
				customers: 'Clienți',
				license: 'Licență | Licențe',
				licenseId: 'ID',
				allCustomers: 'Toți clienții',
				allLicenses: 'Toate licențele',
				serial: 'Serial',
				product: 'Produs',
				validFrom: 'Valid de la',
				validTill: 'Valid până',
				used: 'Folosit',
				limit: 'Limită',
				status: 'Status',
				competitive: 'Competitiv',
				searchPlaceholder: 'Serial, produs',
				domain: 'Domeniu',
				daysToExpire: {
					0: 'Expirat',
					30: '30 sau mai puțin',
					90: '90 sau mai puțin',
					days: ' zile',
				},
				importLicense: 'Import licență',
				licenseKey: 'Cheie de licență',
			},
			devices: {
				devices: 'Dispozitiv | Dispozitive',
				newDevice: 'Dispozitiv nou',
				newDeviceDescription: 'Descriere dispozitiv nou',
				allDevices: 'Toate dispozitivele',
				searchPlaceholder: 'Nume, utilizator, ID autentificare & ID birou',
				authId: 'ID autentificare',
				presence: 'Prezență',
				hotdesk: 'Birou cald',
				hotdeskDevice: 'Dispozitiv birou cald',
				hotdeskDeviceSettings: 'Setări dispozitiv birou cald',
				hotdeskIncorrectInput: 'Nume gresit',
				hotdeskInputHint:
					'Pentru a facilita identificarea acestui dispozitiv, ar trebui să-l acoperiți cu aliasuri prietenoase de birou cald. Numele valid trebuie să conțină următoarele caractere: A-Z, a-z, 0-9, -, _',
				deviceSettings: 'Setări dispozitiv',
				hostName: 'Nume gazdă',
				phoneInfo: 'Informații telefon',
				phone: 'Telefon',
				vendor: 'Furnizor',
				model: 'Model',
				ipv4: 'IPv4',
				mac: 'MAC',
				deviceHistory: 'Istoric dispozitiv',
				loggedIn: 'Autentificat',
				loggedOut: 'Deconectat',
				state: {
					nonreg: 'Neregistrat',
					reged: 'Înregistrat',
					ringing: 'Sună',
					dialing: 'Dială',
					dialog: 'Dialog',
					onhold: 'Pe hol',
				},
				passwordSetFromAccount:
					'Dacă nu setați parola, va fi aceeași ca și contul',
				csvMappingFields: {
					account: ({ linked }) => linked('webitelUI.headerActions.account'),
					name: ({ linked }) => linked('reusable.name'),
					password: ({ linked }) => linked('vocabulary.password'),
					vendor: 'Producător',
					model: 'Model',
					mac: 'Adresă MAC',
					ip: 'Adresă IP',
				},
			},
		},
		permissions: {
			permissions: 'Permisiuni',
			permissionsRole: 'Rol | Roluri',
			allRoles: 'Toate rolurile',
			searchPlaceholder: 'rol ..',
			roles: {
				permissions: {
					permissions: 'Permisiune rol | Permisiuni rol',
					add: 'Adaugă',
					delete: 'Șterge',
					read: 'Selectează',
					write: 'Actualizează',
					eavesdropCall: 'Ascultă apel',
					playbackRecordFile: 'Redă fișiere de înregistrare',
					timeLimitedRecordFile: 'Redă fișiere de înregistrare cu timp limitat',
					resetActiveAttempts: 'Resetează încercări active',
					limitWorkspaceContacts: 'Limitează contacte în Workspace',
					exportDataGrid: 'Exportați grila de date',
					viewCdrPhoneNumbers: 'Vedeți numerele de telefon CDR',
					manageUserRoles: 'Gestionați rolurile utilizatorilor',
					manageUserLicense: 'Gestionați licențele utilizatorilor',
					changeUserPassword: 'Schimbați parola utilizatorilor',
					systemSetting: 'Gestionați configurațiile sistemului',
					addDescription: 'Permite crearea oricăror obiecte',
					deleteDescription: 'Permite eliminarea oricăror obiecte',
					readDescription: 'Permite selectarea oricăror obiecte',
					writeDescription: 'Permite modificarea oricăror obiecte',
					eavesdropCallDescription:
						'Permite ascultarea unei conversații active',
					playbackRecordFileDescription:
						'Permite redarea fișierelor de înregistrare a apelurilor',
					timeLimitedRecordFileDescription:
						'Permite redarea fișierelor de înregistrare a apelurilor cu timp limitat',
					resetActiveAttemptsDescription:
						'Permite resetarea încercărilor active',
					limitWorkspaceContactsDescription:
						'Limitează permisiunea de a vedea lista contactelor în Workspace',
					exportDataGridDescription:
						'Permite exportarea grilor de date într-un fișier',
					viewCdrPhoneNumbersDescription: 'Vedeți numerele de telefon CDR',
					manageUserRolesDescription:
						'Permite gestionarea unui set de roluri de utilizator',
					manageUserLicenseDescription:
						'Permite gestionarea unui set de licență de utilizator',
					changeUserPasswordDescription:
						'Permite schimbarea parolei utilizatorilor',
					systemSettingDescription:
						'Permite accesarea și gestionarea secțiunii de configurații',
					schemeVariables: 'Gestionați variabilele globale',
					controlAgentScreen: 'Controlul ecranului agentului',
					schemeVariablesDescription:
						'Permite accesarea și gestionarea secțiunii de variabile globale',
				},
				addPermission: 'Adaugă permisiune rol',
				usage: 'Utilizare',
				applicationsAccess: {
					applicationsAccess: 'Acces la aplicații | Acces la aplicații',
					access: 'Acces',
				},
			},
			object: {
				object: 'Obiecte',
				allObjects: 'Toate obiectele',
				ObAC: 'Gestionat de operațiuni',
				RbAC: 'Gestionat de înregistrări',
				operations: 'Operațiuni',
				searchPlaceholder: 'obiect ..',
				newPermissionRole: 'Noul beneficiar',
				rbacDefault: 'Acces implicit bazat pe înregistrare',
				grantor: 'Garant',
				grantee: 'Beneficiar',
				create: 'Creează',
				delete: 'Șterge',
				accessMode: {
					1: 'Interzis',
					2: 'Permis',
					3: 'Permis cu delegare',
				},
			},
		},
		lookups: {
			lookups: 'Căutări',
			skills: {
				skills: 'Competență | Competențe',
				capacity: 'Capacitate',
				minCapacity: 'Capacitate minimă',
				minCapacityLessOrEqualToMaxCapacityValidator:
					'Ar trebui să fie mai mic sau egal cu capacitatea maximă',
				maxCapacity: 'Capacitate maximă',
				maxCapacityMoreOrEqualToMinCapacityValidator:
					'Ar trebui să fie mai mare sau egal cu capacitatea minimă',
				lvl: 'Nivel',
				agentSkills: 'Competență agent | Competențe agent',
				allSkills: 'Toate competențele',
				state: 'Stare',
				stateForAll: 'Stare pentru toate',
				changeSkillTo: 'Schimbă competența în',
				changeAgentsSkill: 'Schimbă competența agentului',
				totalAgents: 'Total agenți',
				activeSkillAgents: 'Agenți cu competență activă',
				assignSkillToAgents: 'Atribuie competența agenților',
				assignAgent: 'Atribuie agent',
				selectCapacityAndState: 'Selectează capacitate și stare',
			},
			buckets: {
				buckets: 'Balon | Baloane',
				allBuckets: 'Toate baloanele',
				addBucket: 'Adaugă balon',
			},
			blacklist: {
				blacklist: 'Listă | Liste',
				allBlacklists: 'Toate listele',
				number: 'Număr | Numere',
				newNumber: 'Număr nou',
				numbersCount: 'Numere',
				expireAt: 'Expiră',
				temporary: 'Temporar',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
					description: ({ linked }) => linked('vocabulary.description'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
				},
				importResult:
					'Numere importate: {imported}. Duplicate omise: {skipped}.',
			},
			media: {
				mediaFiles: 'Fișier mediu | Fișiere media',
				allMediaFiles: 'Toate fișierele media',
				createdAt: 'Creat',
				format: 'Format',
				size: 'Mărime',
				textToSpeech: 'Text în vorbire',
				popupSettings: 'Setări',
				lang: 'Limbă',
				voice: 'Voce',
				token: 'Token',
				key: 'Cheie',
				dragPlaceholder: 'Trage și aruncă fișiere',
				dragPlaceholderHere: 'aici.',
				tts: {
					hint: 'Creează un fișier audio',
					textType: {
						textType: 'Tip text',
						ssml: 'SSML',
					},
				},
			},
			regions: {
				regions: 'Locație | Locații',
				allRegions: 'Toate locațiile',
			},
			timezone: {
				timezone: 'Fus orar | Fus orare',
			},
			calendars: {
				calendars: 'Calendar | Calendare',
				allCalendars: 'Toate calendarele',
				searchPlaceholder: 'Nume, descriere...',
				timezone: 'Fus orar',
				start: 'Începe',
				end: 'Se termină',
				workWeek: 'Săptămâna de lucru',
				specialTime: 'Timp special',
				holidays: 'Sărbătoare | Sărbători',
				date: 'Dată',
				repeat: 'Repetă',
				fulltime: 'Temporar',
				everyYear: 'Repetă anual',
				newHoliday: 'Sărbătoare nouă',
				mon: 'Luni',
				tue: 'Marți',
				wed: 'Miercuri',
				thu: 'Joi',
				fri: 'Vineri',
				sat: 'Sâmbătă',
				sun: 'Duminică',
				workingTime: 'Timp de lucru',
				workStart: 'Începe timp de lucru',
				workStop: 'Se termină timp de lucru',
			},
			communications: {
				communications: 'Tip de comunicare | Tipuri de comunicare',
				allCommunications: 'Toate tipurile de comunicare',
				addCommunication: 'Adaugă comunicare',
				missingCommunication: 'Vă rugăm să adăugați un tip de comunicare',
				code: 'Cod',
				channels: {
					[EngineCommunicationChannels.Phone]: 'Telefon',
					[EngineCommunicationChannels.Email]: 'Email',
					[EngineCommunicationChannels.Messaging]: 'Mesagerie',
				},
			},
			pauseCause: {
				pauseCause: 'Motive de pauză',
				allPauseCause: 'Toate cauzele de pauză a agentului',
				limit: 'Limită (min)',
				min: 'min',
				allowAdmin: 'Admin poate schimba această stare',
				allowSupervisor: 'Supraveghetor poate schimba această stare',
				allowAgent: 'Agent poate schimba această stare',
			},
			quickReplies: {
				quickReplies: 'Răspuns rapid | Răspunsuri rapide',
			},
			activityTypes: {
				activityTypes: 'Tip de activitate | Tipuri de activitate',
			},
		},
		routing: {
			routing: 'Rutare',
			ip: 'IP',
			protocol: 'Protocol',
			port: 'Port',
			configuration: 'Configurare',
			schema: 'Schema flux',
			json: 'JSON',

			flow: {
				flow: 'Schema flux | Scheme de flux',
				allFlowSchemas: 'Toate schemele de flux',
				createFlowSelectionPopup: 'Creează un nou flux',
				createNew: 'Creează nou?',
				editor: 'Editor',
				diagram: {
					diagram: 'Diagramă',
					description:
						'Creează un nou flux folosind instrumentul Webitel Flow Diagram',
				},
				code: {
					code: 'Cod',
					description:
						'Creează un nou flux folosind un editor de cod JSON-schema',
				},
				askingAlert: 'Vrei să salvezi modificările făcute la "{name}" ?',
			},

			dialplan: {
				dialplan: 'Dialplanuri',
				dialplanRules: 'Reguli dialplan',
				pattern: 'Număr de destinație',
				dialplanRule: 'Regulă dialplan',
				position: 'Poziție',
				allowTransfer: 'Permite transferul',
			},

			chatplan: {
				chatplan: 'Chatplan | Chatplans',
				allChatplans: 'Toate chatplanurile',
			},

			gateways: {
				gateways: 'Gateway | Gateways',
				allGateways: 'Toate gateway-urile',
				trunkingGateway: 'Gateway de trunking',
				registerGateway: 'Gateway de înregistrare',
				stateSuccess: 'Succes',
				stateFailed: 'Eșuat',
				stateProgress: 'În curs de execuție',
				stateNonreg: 'Neregistrat',
				proxy: 'Proxy',
				searchPlaceholder: 'caută gateway...',
				host: 'Gazdă',
				trunkingACL: 'Listă de control acces trunking',
				hostnameTrunking: 'Nume gazdă/Gateway sau IP',
				hostnameRegister: 'Nume gazdă/Server/Gateway sau IP',
				expire: 'Expiră',
				authID: 'Nume utilizator',
				account: 'Cont',
				outboundProxy: 'Gazdă outbound sau IP',
				newGateway: 'Gateway nou',
				newGatewayDescription: 'Descriere gateway nou',
				SIPregistrations: 'Înregistrare SIP',
				SIPregistrationsDescription: 'Descriere înregistrare SIP',
				SIPtrunking: 'Trunking SIP',
				SIPtrunkingDescription: 'Descriere trunking SIP',
			},
			chatGateways: {
				templates: {
					templates: 'Șablon | Șabloane',
					title: 'Nume membru de workspace',
					close: 'Mesaj completare chat',
					join: 'Mesaj intrare agent',
					left: 'Mesaj deconectare agent',
					filePolicyFail: 'Format de fișier interzis',
				},
				chatGateways: 'Gateway chat | Gateway-uri chat',
				allChatGateways: 'Toate gateway-urile chat',
				telegramBot: {
					telegramBot: 'Bot Telegram',
				},
				telegramApp: {
					telegramApp: 'Aplicativ Telegram',
					signedAs: 'Ești înregistrat ca',
					joinTelegram: 'Autentifică-te la Telegram',
					signOut: 'Deconectează-te de la Telegram',
					metadata: {
						apiId: 'ID API',
						apiHash: 'Hash API',
					},
				},
				infobip: {
					infobip: 'Infobip',
				},
				messenger: {
					meta: 'Meta',
					addOrRemovePages: 'Adaugă sau elimină pagini',
					accounts: 'Conturi',
					metadata: {
						clientId: 'ID aplicație',
						clientSecret: 'Secret aplicație',
						apiVersion: 'Versiune API',
						apiVersionHint: 'Format: vXX.X (de exemplu, v24.0)',
					},
					facebook: {
						pages: 'Pagini Facebook',
						subscription: 'Abonament webhook',
					},
					instagram: {
						instagram: 'Instagram',
						comments: 'Urmăriți comentarii',
						mentions: 'Urmăriți menționări',
					},
					whatsapp: {
						whatsapp: 'Whatsapp',
						token: 'Token',
						status: 'Status',
						number: 'Număr de telefon',
						review: 'Recenzie',
					},
				},
				viber: {
					viber: 'Viber',
					style: {
						style: 'Stil',
						btnBackColor: 'Culoare fundal buton',
						btnFontColor: 'Culoare font buton',
					},
				},
				webchat: {
					webchat: 'Chat web',
					copyCode: 'Copiază cod pentru site',
					copyCodeHint:
						'Trebuie să regenerezi și să reintroduceți codul Widget în website după fiecare modificare a setărilor Widget',
					metadata: {
						mediaMaxSize: 'Mărime maximă mediu (MB)',
					},
					view: {
						view: 'Vezi',
						borderRadius: 'Formă buton',
						language: 'Limbă',
						position: 'Poziție',
						btnColor: 'Culoare buton',
						logoUrl: 'URL logo',
						logoHint: 'Formatul logo acceptat este "JPEG" sau "PNG", 24x24px',
						rounded: 'Rotunjit',
						square: 'Pătrat',
						right: 'Dreapta',
						left: 'Stânga',
					},
					recaptcha: {
						recaptcha: 'reCAPTCHA',
						sitekey: 'Cheie site',
						secret: 'Secret cheie',
						threshold: 'Tesă',
						showFlag: 'Arată badge reCAPTCHA',
					},
					chat: {
						chat: 'Chat',
						openTimeout: 'Timp deschidere',
						openTimeoutSec: 'Timp deschidere Sec',
					},
					appointment: {
						appointment: 'Programare',
						days: 'Zile',
						availableAgents: 'Agenți disponibili',
						showEmailField: 'Arată câmp email',
						showMessageField: 'Arată câmp mesaj',
						resultPageText: 'Text pagină rezultat',
						headingText: 'Text antet',
						subheadingText: 'Text subantet',
						showDefaultHeading:
							'Arată antet și subantet implicit pe pagina rezultat',
					},
					alternativeChannels: {
						alternativeChannels: 'Canale alternative',
						title: 'Canale de mesagerie',
						email: 'Email',
						whatsapp: 'WhatsApp',
						telegram: 'Telegram',
						messenger: 'Mesagerie',
					},
					call: {
						title: 'Apel online',
						url: 'Endpoint WebSocket',
					},
				},
				customChat: {
					customChat: 'Chat personalizat',
					customChatGateway: 'Gateway chat personalizat',
					appSecretHint: 'Modificarea acestui câmp va întrerupe integrarea',
					metadata: {
						appSecret: 'Secret aplicație',
						callback: 'Callback',
					},
				},
				uri: 'URI',
				newChatGateway: 'Gateway chat nou',
				metadata: {
					apiKey: 'Cheie API',
					baseUrl: 'URL bază',
					allowOrigin: 'Permite Origină',
					readTimeout: 'Timp citire (sec)',
					writeTimeout: 'Timp scriere (sec)',
					handshakeTimeout: 'Timp handshake (sec)',
					botName: 'Nume bot',
					telegramToken: 'Token API BOT Telegram',
				},
			},

			callflow: {
				callflow: 'Callflow',
			},
		},

		ccenter: {
			ccenter: 'Centru de contact',

			agents: {
				agents: 'Agent | Agenți',
				supervisors: 'Supraveghetor | Supraveghetoare',
				admins: 'Admin | Admini',
				subordinates: 'Agent subordonat | Agenți subordonati',
				allAgents: 'Toți agenții',
				chatCount: 'Număr mesaje chat',
				taskCount: 'Număr sarcini',
				progressiveCountValidator:
					'Valoarea trebuie să fie mai mare decât 1 sau goală',
				extraChatCount: 'Număr suplimentar de chat-uri',
				state: 'Stare',
				isSupervisor: 'Supraveghetor',
				stateTime: 'Timp stare',
				statusType: 'Tip stare',
				addSkill: 'Adaugă competență',
				editSkill: 'Editează competență',
				statusHistory: 'Istoric stare',
				historyState: 'Stare',
				payload: 'Motiv',
				addSubordinate: 'Adaugă agent subordonat',
				historyChannel: 'Canal',
				historyFrom: 'De la',
				historyTo: 'La',
				historyDuration: 'Durata',
				emptyPopup: 'Vă rugăm să verificați interogarea filtrelor',
				status: {
					online: 'Online',
					offline: 'Offline',
					pause: 'Pauză',
					breakOut: 'Ieșire din pauză',
				},
				wfm: 'WFM',
				workingConditions: 'Condiții de lucru',
				pauseTemplate: 'Șablon de pauză',
				agentScreenControl: 'Control ecran agent',
				agentScreenControlHint:
					'Nu poate fi dezactivat cât timp setarea pentru echipă este activată.',
			},

			auditors: {
				auditors: 'Supraveghetor | Supraveghetoare',
			},

			teams: {
				teams: 'Echipă | Echipe',
				allTeams: 'Toate echipele',
				strategy: 'Strategie',
				parameters: 'Parametri',
				maxNoAnswer: 'Număr maxim de activități pierdute',
				callTimeout: 'Timp de acceptare apel',
				inviteChatTimeout: 'Timp de acceptare chat',
				wrapUpTime: 'Timp de încheiere',
				noAnswerDelayTime: 'Timp de întârziere după activitate pierdută',
				taskAcceptTimeout: 'Timp de acceptare sarcină',
				strategies: {
					random: 'Aleatoriu',
					fewestCalls: 'Agent cu cele mai puține apeluri',
					leastTalkTime: 'Agent cu cel mai puțin timp de vorbire',
					topDown: 'De sus în jos',
					roundRobin: 'Rotunjit',
					roundRobinBucket: 'Balon rotunjit',
					longestIdleAgent: 'Agent cu timp de inactivitate cel mai lung',
					skillCapacity: 'După nivel competență',
				},
				hooks: {
					eventTypes: {
						agentStatus: 'Starea agentului s-a schimbat',
					},
				},
				flows: {
					addFlowSchema: 'Adaugă schema flux',
					editFlowSchema: 'Editează schema flux',
				},
				supervisors: {
					addSupervisor: 'Adaugă supraveghetor',
					editSupervisor: 'Editează supraveghetor',
				},
				agents: {
					addAgent: 'Adaugă agent',
					editAgent: 'Editează agent',
				},
			},

			members: {
				members: 'Membru | Membri',
				allMembers: 'Toți membrii',
				addMember: 'Adaugă membru',
				destination: 'Destinație',
				communications: 'Comunicații',
				display: 'Număr de afișare',
				dtmf: 'DTMF',
				priority: ({ linked }) => linked('objects.memberPriority'),
				attempts: 'Încercări',
				emptyWorkspace: 'Nu au fost găsiți membri',
				resetMembers: {
					resetMembers: 'Resetează membri',
					description: {
						question: 'Sunteți sigur că doriți să resetați încercările eșuate',
						all: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} fără nicio limită de dată?`,
						filtered: ({ named, linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')} din perioada\n${named('dateFrom')} până la ${named('dateTo')}\nținând cont de filtrele aplicate și de rezultatele căutării?`,
						selected: ({ linked }) =>
							`${linked('objects.ccenter.members.resetMembers.description.question')}?`,
					},
					descriptionCount: 'Vor fi afectate {count} înregistrări.',
					emptyDescription:
						'Nu există încercări eșuate care să corespundă filtrelor curente. Nu este nimic de resetat.',
					reset: 'Resetează',
					successResetCount: 'Succes la reseta {count} membri',
				},
				exportMembers: {
					exportMembers: 'Exportă membri',
				},
				endCause: {
					abandoned: ({ linked }) => linked('objects.stopCause.abandoned'),
					timeout: ({ linked }) => linked('objects.stopCause.timeout'),
					cancel: ({ linked }) => linked('objects.stopCause.cancel'),
					success: ({ linked }) => linked('objects.stopCause.success'),
					failed: ({ linked }) => linked('objects.stopCause.failed'),
					missed: ({ linked }) => linked('objects.stopCause.missed'),
					expired: ({ linked }) => linked('objects.stopCause.expired'),
					canceledByTimeout: ({ linked }) =>
						linked('objects.stopCause.canceledByTimeout'),
				},
				csvMappingFields: {
					name: 'Nume',
					timezoneId: ({ linked }) => linked('date.timezone'),
					priority: ({ linked }) => linked('vocabulary.priority'),
					expireAt: ({ linked }) => linked('vocabulary.expireAt'),
					bucketId: 'Bucket',
					agentId: ({ linked }) => linked('objects.agent.agent'),
					variables: ({ linked }) => linked('vocabulary.variables'),
					destination: ({ linked }) => linked('vocabulary.destination'),
					commPriority: 'Prioritatea tipurilor de comunicare',
					code: 'Cod',
					description: ({ linked }) => linked('vocabulary.description'),
					dtmf: 'DTMF',
				},
			},

			globalStateConfirmation: {
				title: 'Aplică modificările',
				message:
					'Modificările vor fi aplicate la {count} înregistrări. Sunteți sigur?',
			},

			queues: {
				queues: 'Coadă | Cozi',
				allQueues: 'Toate cozile',
				type: 'Tip',
				state: 'Stare',
				active: 'Activ',
				notActive: 'Inactiv',
				activeCalls: 'Apeluri active',
				waiting: 'În așteptare',
				ringtone: 'Ton',
				priority: 'Prioritate',
				teams: 'Echipă | Echipe',
				tags: 'Etichete',
				newQueue: 'Coadă nouă',
				saveBeforeAddingRecords:
					'Completați câmpurile obligatorii ale cozii înainte de a adăuga înregistrări',
				blacklist: 'Listă de oprire',
				resources: ({ linked }) => linked('objects.ccenter.res.res'),
				resourceGroups: ({ linked }) =>
					linked('objects.ccenter.resGroups.resGroups'),
				newQueueDescription: 'Descriere coadă nouă',
				outboundIVRQueue: 'Coadă IVR outbound',
				outboundIVR: 'IVR outbound',
				outboundIVRQueueDescription:
					'Un IVR outbound permite organizației să engageze clienții automat prin mai multe canale, cum ar fi apeluri vocale automate, mesaje SMS, email sau postări pe rețelele sociale folosind notificări personalizate.',
				inboundQueue: 'Coadă inbound',
				inboundQueueDescription:
					'O coadă inbound este unde sunt așezați clienții în așteptare, într-o coadă, în timp ce așteaptă să vorbească cu un agent în viață.',
				offlineQueue: 'Coadă offline',
				offlineQueueDescription:
					'O coadă offline oferă clienților opțiunea de a opri așteptarea în așteptare, să introducă numărul de telefon și să primească un apel de revenire în momentul în care este rândul lor.',
				previewDialer: 'Dialer de previzualizare',
				previewDialerDescription:
					'Previzualizați contactul înainte de a-l auto-dializa.',
				progressiveDialer: 'Dialer progresiv',
				progressiveDialerDescription:
					'Dialarea progresivă minimizează timpul pierdut între apeluri prin auto-dialarea unui număr din lista de apeluri în momentul în care un agent devine disponibil.',
				predictiveDialer: 'Dialer predictiv',
				predictiveDialerDescription:
					'Un dialer predictiv apelează mai multe numere în același timp. În momentul în care un client răspunde, un agent este conectat la el.',
				chatInboundQueue: 'Coadă inbound chat',
				chatInboundQueueDescription:
					'La fel ca și coada inbound, dar cu chat-uri',
				imChatQueue: 'Coadă chat IM',
				imChatQueueDescription:
					'La fel ca și coada de chat, dar pentru mesagerie instant',
				inboundJobQueue: 'Coadă sarcină inbound',
				inboundJobQueueDescription: 'Coadă sarcină inbound',
				outboundJobQueue: 'Coadă sarcină outbound',
				outboundJobQueueDescription: 'Coadă sarcină outbound',
				strategy: 'Strategie',
				timezone: 'Fus orar',
				callLimit: 'Limit apel',
				variables: 'Variabile',
				members: 'Membru | Membri',
				params: 'Parametri',
				discardAbandonedAfter: 'Elimină abandonat după',
				maxIdleAgent: 'Timp de răspuns a agentului',
				maxIdleClient: 'Timp de răspuns a clientului',
				maxIdleDialog: 'Timp maxim de răspuns',
				timeoutWithNoAgents: 'Timp de așteptare cu niciun agent',
				timeBaseScore: 'Scor bazat pe timp',
				endless: 'Nelimitat',
				stickyAgent: 'Agent lipit',
				stickyAgentSec: 'Agent lipit (sec)',
				autoAnswerTone: 'Tone de avertizare auto-răspuns',
				varKey: 'Cheie',
				varVal: 'Valoare',
				endCause: ({ linked }) => linked('objects.stopCause.stopCause'),
				offeringAt: 'Ofertat la',
				destination: 'Destinație | Destinații',
				expire: 'Expiră',
				originateTimeout: 'Timp de origine',
				maxAgentLine: 'Linii maxime agent',
				maxAgentLose: 'Apeluri maxime pierdute de agent',
				minAttempts: 'Încercări predictiv minime',
				maxAbandonedRate: 'Rata abandon % maximă',
				loadFactor: 'Factor de încărcare',
				abandonRateAdjustment: 'Ajustare rata abandon',
				playbackSilence: 'Silențiu redare',
				targetAbandonedRate: 'Rata abandonare tinta %',
				maxWaitTime: 'Timp de așteptare maxim',
				maxWaitingSize: 'Număr maxim de așteptare',
				waitBetweenRetries: 'Așteptă între retrageri',
				waitBetweenRetriesDesc: 'Sortează retragerile membrii descrescător',
				strictCircuit: 'Circuit strict',
				retryAbandoned: 'Repornește abandonat',
				playbackFile: 'Fișier redare',
				timeout: 'Timp de așteptare',
				maxNumberOfRetry: 'Număr maxim de retrageri',
				minDuration: 'Durata apelului cu succes minimă',
				maxAttempts: 'Încercări maxime',
				minOnlineAgents:
					'Acces la pauză când sunt mai mulți agenți online decât',
				waitForResultStatus: 'Așteaptă status rezultat',
				bucketPriority: 'Prioritate',
				amd: 'AMD',
				enabled: 'Folosește AMD',
				ai: 'Intelegență artificială',
				positiveLabels: 'Etichete pozitive',
				aiPlayback: 'Fișier redare',
				allowNotSure: 'Transferă NOTSURE către un agent',
				silenceNotSure: 'Transferă silențiu către un agent',
				allowGreetingAgent: 'Permite salutul agentului',
				preSchema: 'Schema pre-executivă',
				afterSchema: 'Schema post-executivă',
				maxCalls: 'Sarcini maxime',
				dialingRate: 'Rata dialării',
				maxCallsHint: 'Dacă valoarea este 0, nu se efectuează sarcini',
				recordings: 'Înregistrare',
				recordAll: 'Începe înregistrarea după răspuns',
				perNumbers: 'Încercări pe număr de telefon',
				maxWordLength: 'Lungime maximă cuvânt (ms)',
				maxNumberOfWords: 'Număr maxim de cuvinte',
				betweenWordsSilence: 'Silențiu între cuvinte (ms)',
				minWordLength: 'Lungime minimă cuvânt (ms)',
				totalAnalysisTime: 'Timp total de analiză (ms)',
				silenceThreshold: 'Tesă silențiu (ms)',
				afterGreetingSilence: 'Silențiu după salut (ms)',
				greeting: 'Salut (ms)',
				initialSilence: 'Silențiu inițial (ms)',
				statisticTime: 'Interval recalculare',
				communications: 'Tip de comunicare',
				manualDistribution: 'Distribuție manuală',
				lastMessageTimeout: 'Timp de așteptare de la ultimul mesaj',
				stickyIgnoreStatus: 'Ignoră starea agentului',
				ignoreCalendar: 'Ignoră calendar',
				resourceStrategy: {
					resourceStrategy: 'Strategie resurse',
					priorityBased: 'Bazat pe prioritate',
					evenDistribution: 'Distribuție egală',
				},
				attemptsReset: {
					resetActiveAttempts: ({ linked }) =>
						linked('objects.permissions.roles.permissions.resetActiveAttempts'),
					title: 'Resetează încercări',
					attemptType: 'Tip încercare',
					idleTime: 'Timp inactiv (min)',
					result: ({ linked }) =>
						linked('objects.integrations.triggers.logs.result'),
					calls: 'Apeluri',
					attemptsCount: 'Încercări',
				},
				processing: {
					processing: 'Procesare',
					enabled: 'Așteaptă rezultat apel',
					formSchema: 'Schema de procesare dinamică',
					sec: 'Timp postprocesare (sec)',
					renewalSec: 'Oferă prelungirea postprocesării când rămân (sec)',
					allowProlongation: 'Permite prelungirea postprocesării',
					autosave: 'Permite salvarea automată a postprocesării',
					repeatsNumber: 'Număr de repetări',
					prolongationTimeSec: 'Timp pentru prelungire (sec)',
					isTimeoutRetry: 'Reîncearcă până la timeout',
				},
				queueStrategy: {
					fifo: 'FIFO (Primul intrat, Primul ieșit)',
					lifo: 'LIFO (Ultimul intrat, Primul ieșit)',
					strict_fifo: 'FIFO strict (Primul intrat, Primul ieșit)',
				},
				logs: {
					logs: 'Log | Logs',
					destination: 'Destinație',
					offeringAt: 'Ofertat',
					joinedAt: 'Începe',
					leavingAt: 'Se termină',
					duration: ({ linked }) => linked('vocabulary.duration'),
					viewNumber: 'Număr de vizualizare',
					result: ({ linked }) => linked('objects.callReportingResult.result'),
					attempts: 'Încercare',
					resultName: {
						abandoned: ({ linked }) =>
							linked('objects.callReportingResult.abandoned'),
						cancel: ({ linked }) =>
							linked('objects.callReportingResult.cancel'),
						success: ({ linked }) =>
							linked('objects.callReportingResult.success'),
						failed: ({ linked }) =>
							linked('objects.callReportingResult.failed'),
						missed: ({ linked }) =>
							linked('objects.callReportingResult.missed'),
						timeout: ({ linked }) =>
							linked('objects.callReportingResult.timeout'),
						endless: ({ linked }) =>
							linked('objects.callReportingResult.endless'),
						transferred: ({ linked }) =>
							linked('objects.callReportingResult.transferred'),
						shutdown: ({ linked }) =>
							linked('objects.callReportingResult.shutdown'),
					},
				},
				hooks: {
					hooks: 'Hook | Hook-uri',
					event: 'Eveniment',
					eventTypes: {
						joined: 'Intrat',
						answered: 'Răspuns',
						offering: 'Ofertat',
						bridged: 'Legat',
						missed: 'Pierdut',
						leaving: 'Părind',
						processing: 'Procesare',
						active: 'Activ',
					},
				},
				skills: {
					editSkill: 'Editează competență',
					addSkill: 'Adaugă competență',
				},
				buckets: {
					addBucket: 'Adaugă balon',
					editBucket: 'Editează balon',
				},
			},

			res: {
				res: 'Resursă | Resurse',
				allRes: 'Toate resursele',
				reserve: 'Rezervă',
				searchPlaceholder: 'nume, gateway..',
				cps: 'CPS',
				limit: 'Limită',
				cidType: 'Tip CID',
				ignoreEarlyMedia: 'Ignoră media timpurie',
				numbers: 'Număr | Numere',
				displayNumbers: 'Numere de afișare',
				failure: 'Eșec',
				maxErrors: 'Răspunsuri de eșec maxim',
				errorCodes: 'Răspunsuri de eșec solicitare',
				patterns: 'Patern număr de destinație',
				priority: 'Prioritate',
				reserveResource: 'Rezervă resursă',
				failureDialDelay: 'Întârziere dialare eșec',
				csvMappingFields: {
					number: ({ linked }) => linked('vocabulary.number'),
				},
			},

			resGroups: {
				resGroups: 'Grup de resurse | Grupuri de resurse',
				allResGroups: 'Toate grupurile de resurse',
				searchPlaceholder: 'nume grup resurse..',
				addResGroup: 'Adaugă grup de resurse',
				editResGroup: 'Editează grup de resurse',
				strategy: 'Strategie',
				timerange: 'Interval de timp',
				timerangeFrom: 'De la',
				timerangeTo: 'La',
			},
		},

		integrations: {
			integrations: 'Integrări',
			emptyWorkspace: 'Nu există profiluri încă',

			storage: {
				storage: 'Stocare',
				allStorages: 'Toate stocările',
				type: 'Tip',
				maxSize: 'Spațiu de stocare (GB)',
				expireDays: 'Durata de viață (zile)',
				priority: 'Prioritate',
				newStorage: 'Stocare nouă',
				newStorageDescription: 'Descriere stocare nouă',
				local: 'Local',
				s3: 'Bucket S3',
				digitalOcean: 'Digital Ocean Spaces',
				backblaze: 'Backblaze B2',
				dropbox: 'Dropbox',
				drive: 'Google Drive',
				configuration: 'Configurare',
				pathPattern: 'Patern cale',
				localFolder: 'Folder local',
				s3Key: 'ID cheie',
				s3Access: 'Cheie acces',
				bucket: 'Balon',
				region: 'Zonă',
				oceanKey: 'ID cheie',
				oceanAccess: 'Cheie acces',
				backblazeAccount: 'ID cont',
				backblazeKey: 'Cheie aplicație',
				backblazeBucketId: 'ID balon',
				dropboxKey: 'Token acces',
				driveFolder: 'Nume folder',
				driveEmail: 'Email Google',
				driveKey: 'Cheie privată',
				s3Endpoint: 'Endpoint',
			},

			storagePolicies: {
				storagePolicies: 'Politica de stocare | Politici de stocare',
				mimeTypes: 'Tipuri MIME',
				retentionDays: 'Zile de reținere',
				maxDownloadSpeed: 'Viteză descărcare maximă (kbps)',
				maxUploadSpeed: 'Viteză încărcare maximă (kbps)',
				maxUploadSize: 'Mărime încărcare maximă (bytes)',
				applyToFiles: 'Aplică zile de retenție la fișiere existente',
				applyPopupMessage:
					'Timpul de reținere nou va fi aplicat fișierelor existente în conformitate cu politica. Vrei să continui?',
				channels: {
					[StorageUploadFileChannel.CallChannel]: 'apel',
					[StorageUploadFileChannel.ChatChannel]: 'chat',
					[StorageUploadFileChannel.MediaChannel]: 'media',
					[StorageUploadFileChannel.MailChannel]: 'email',
					[StorageUploadFileChannel.LogChannel]: 'log',
					[StorageUploadFileChannel.ScreenRecordingChannel]:
						'înregistrări ecran',
				},
				encryptFile: 'Criptați fișiere noi',
				encryptFileHint:
					'Nu veți putea decripta fișierele dacă cheia de criptare este pierdută! Înregistrările pot fi accesate doar prin API sau interfață.',
				encryptionAlertTitle: 'Alertă de criptare',
				encryptionEnableMessage: 'Doar fișierele noi vor fi criptate.',
				encryptionDisableMessage:
					'Fișierele vechi vor rămâne criptate.\nFișierele noi nu vor fi criptate.',
			},

			cognitiveProfiles: {
				cognitiveProfiles: 'Profil cognitiv | Profiluri cognitice',
				properties: {
					region: 'Zonă',
					locale: 'Limbă',
				},
			},
			emailProfiles: {
				emailProfiles: 'Profil email | Profiluri email',
				mailbox: 'Cutie poștală',
				smtpPort: 'Port SMTP',
				imapPort: 'Port IMAP',
				smtpHost: 'Gazdă SMTP',
				imapHost: 'Gazdă IMAP',
				fetchInterval: 'Interval de reîncărcare',
				listen: 'Ascultă',
				authType: 'Tip autentificare',
				authenticatedAs: 'Autentificat ca',
			},
			singleSignOn: {
				singleSignOn: 'Profil SSO | Profile SSO',
				provider: 'Furnizor',
				clientId: 'Application (client) ID',
				clientSecret: 'Client secret',
				discoveryUrl: 'Discovery URL',
				scopes: 'Domenii de acces',
				scopesPlaceholder: 'Introduceți un domeniu și apăsați Enter',
				inspect: 'Inspect',
				inspectHint: 'Trimiteți o cerere furnizorului și primiți un token',
				token: 'Token',
				showToken: 'Afișați tokenul',
				inspectDescription:
					'Trimiteți o cerere furnizorului și primiți un token',
				mapping: 'Mapare',
				mappingKeyHint:
					'Introduceți un atribut de utilizator (de ex., email, username, extension) ca cheie de căutare.',
			},

			importCsv: {
				importCsv: 'Import CSV din fișier | Importuri de CSV din fișier',
				allImportsCsv: 'Toate datele de import din fișiere CSV',
				source: 'Destinație import',
				settings: 'Setări',
				mappings: 'Mapează câmpuri',
				mappingsHint:
					'În această secțiune trebuie să furnizați numele coloanelor fișierului CSV în câmpurile de mai jos în conformitate cu etichetele sale',
				columnHeader: 'Coloană {name}',
				members: {
					clearMembers: 'Curățați membrii existenți',
				},
			},

			tokens: {
				tokens: 'Token | Tokenuri',
				allTokens: 'Toate tokenurile',
				expires: 'Expiră la',
				popupMessage:
					'Descărcați fișierul cheie acum sau copiați-l. Dacă nu descărcați fișierul cheie acum, nu veți putea să recuperați cheia tokenului din nou. Pentru a vă proteja securitatea, stocați cheia tokenului în siguranță și nu o împărtiți.',
				tokenCreated: 'Tokenul a fost creat cu succes!',
			},

			triggers: {
				triggers: 'Trigger | Triggere',
				allTriggers: 'Toate trigger-urile',
				type: 'Tip',
				schema: 'Schema',
				newTrigger: 'Trigger nou',
				newTriggerDescription:
					'Alege un șablon pentru a începe sau pornește de la zero cu un canvas gol',
				event: 'La eveniment',
				onEventDescription: 'Un planificator JSON Schema bazat pe evenimente',
				cron: 'La timp',
				atTimeDescription: 'Un planificator JSON Schema bazat pe timp',
				eventSelect: ({ linked }) =>
					linked('objects.ccenter.queues.hooks.event'),
				cases: 'Cazuri',
				caseFiles: 'Fișiere caz',
				caseComments: 'Comentarii caz',
				caseLinks: 'Legături caz',
				call: 'Apel',
				relatedCases: 'Cazuri legate',
				expression: 'Expresie',
				timeout: 'Timp de așteptare',
				resolutionTime: ({ linked }) => linked('cases.resolutionTime'),
				logs: {
					logs: 'Istoric rulare',
					startedAt: 'Începe',
					result: 'Rezultat',
				},
				recordCall: 'Înregistrează apelul',
				runTrigger: 'Rulează trigger-ul',
			},
		},
		system: {
			system: 'Sistem',
			changelogs: {
				changelogs: 'Jurnal de schimbări | Jurnale de schimbări',
				objects: 'Obiect | Obiecte',
				daysToStore: 'Zile de stocare',
				storage: 'Descarcă la',
				logs: {
					logs: 'Log | Logs',
					actions: 'Operațiune | Operațiuni',
					records: 'ID înregistrare | ID înregistrări',
					actionType: {
						[LoggerAction.Create]: 'Creare',
						[LoggerAction.Delete]: 'Ștergere',
						[LoggerAction.Update]: 'Editează',
					},
				},
				period: {
					period: 'Perioadă',
					options: {
						daily: 'Zilnic',
						weekly: 'Săptămânal',
						fortnightly: 'De 2 săptămâni',
						monthly: 'Lunăr',
					},
				},
			},
			configuration: {
				configuration: 'Configurare | Configurații',
				parameter: 'Parametru',
			},
			globalVariables: {
				globalVariables: 'Variabilă globală | Variabile globale',
				encrypted: 'Criptat',
				valueInfo: 'Introduceți valoarea doar dacă doriți să o editați',
				newTitle: 'Variabilă globală nouă',
				editTitle: 'Editează variabilă globală',
			},
		},

		pagination: {
			rowsPerPage: 'Rânduri pe pagină',
		},
	},

	filters: {
		team: 'Echipă',
		queueType: 'Tip coadă',
	},

	webitelUI: {
		filters: {
			tags: ({ linked }) => linked('vocabulary.tag'),
			joinedAt: ({ linked }) => linked('objects.joinedAt'),
			result: ({ linked }) => linked('objects.callReportingResult.result'),
			duration: ({ linked }) => linked('vocabulary.duration'),
		},
	},

	utils: {
		downloadFilesBtn: {
			downloadFiles: 'Descarcă fișiere',
			filesLoaded: 'Fișiere încărcate',
			zippingProgress: 'Progres zipping',
		},
	},

	errorPages: {
		goToHome: 'Vai la pagina principală',
		page403: {
			title: 'Acces refuzat',
			text: 'Scuze, nu ai privilegii suficiente pentru a vedea această pagină.',
		},
		page404: {
			title: 'Pare să te-ai pierdut',
			text: 'Scuze, nu putem găsi pagina pe care o căutai.',
		},
	},

	icon: {
		docs: 'Documentație',
		logout: 'Deconectare',
		account: 'Cont',
		appNavigator: 'Navigator aplicație',
		settings: 'Setări',
	},

	iconHints: {
		upload: 'Încarcă',
		reload: 'Reîncarcă tabel',
		edit: 'Editează',
		delete: 'Șterge',
		deleteAll: 'Șterge toate elementele',
		deleteSelected: 'Șterge {count} elemente selectate',
		deleteFiltered: 'Șterge toate elementele filtrate',
		resetAll: 'Resetează toți membrii',
		resetSelected:
			'Resetează {count} membru selectat | Resetează {count} membri selectați',
		resetFiltered: 'Resetează toți membrii filtrați',
		generate: 'Generează',
		add: 'Adaugă',
		history: 'Istoric',
		download: 'Descarcă',
		downloadAll: 'Descarcă toate',
		draggable: 'Tragebil',
		play: 'Redă',
		pause: 'Pauză',
		resume: 'Repornește',
		close: 'Închide',
		change: 'Schimbă',
		volume: 'Volum',
		stop: 'Oprire',
		members: 'Membri',
		moveUp: 'Mare în sus',
		moveDown: 'Mare în jos',
		nextPage: 'Pagina următoare',
		prevPage: 'Pagina anterioară',
		expand: 'Extinde',
		collapse: 'Restinge',
	},
	errors: {
		invalidJson: 'JSON este invalid',
	},
	reusable: {
		time: {
			t15m: '15 min',
			t30m: '30 min',
			t45m: '45 min',
			t1h: '1 oră',
			t3h: '4 ore',
			t6h: '6 ore',
		},
	},
};
